import React from 'react';
import { Box, useToken } from '@chakra-ui/react';
import Loader from '../Loader';

const PDFLoading = () => {
    const [loaderColour] = useToken('colors', ['gray.600']);
    return (
        <Box w="100%" my={12} textAlign="center">
            <Loader color={loaderColour} />
        </Box>
    );
};

export default PDFLoading;
